<template>
<div>
    <div class="row col-md-12" id="tabs" style="margin: -3px 0 0 0;  border-bottom: 1px solid #93a8d6;">
       <template>
        <div class="form-group mb-0 ml-1" id="tab_list" v-if="weekendFilters.length > 0"  >
          <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
            <li class="nav-item type1 mr-4">
              <a
                class="nav-link demo px-4" v-bind:class="{ active: selectTabFilter === 'lastWeek' }" href="javascript:void(0);" @click="filterByDate('lastWeek')">Last Week</a >
            </li>
            <li class="nav-item type1 mr-4">
              <a class="nav-link demo px-4" v-bind:class="{ active: selectTabFilter === 'thisWeek' }" href="javascript:void(0);" @click="filterByDate('thisWeek')">This Week</a>
            </li>
            <li class="nav-item type1 mr-4">
              <a class="nav-link demo px-4" v-bind:class="{ active: selectTabFilter === 'nextWeek' }" href="javascript:void(0);" @click="filterByDate('nextWeek')" >Next Week</a>
            </li>
          </ul>
          <!-- <div v-for="task in filteredTasks" :key="task.id">
        {{ task.title }}
      </div> -->
       </div>
        <div class="form-group mb-0 ml-1" id="tab_list" v-else>
            <ul class="nav nav-pills mobile-nav" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
              <li class="nav-item type1 mr-4">
                  <a class=" nav-link demo px-4" v-bind:class="[selectTab == 'all' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('all')" @click="taskStatus('all')" >All</a>
              </li>
               <li class="nav-item type1 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 0 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(0)" @click="taskStatus(0)">Pending</a>
              </li>
              <li class="nav-item type3 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 5 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(4)" @click="taskStatus(5)">In Review</a>
              </li>
              <li class="nav-item type1 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 1 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(1)" @click="taskStatus(1)">Assigned</a>
              </li>
              <li class="nav-item type2 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 2 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(2)" @click="taskStatus(2)">In Progress</a>
              </li>
              <!-- <li class="nav-item type3 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 6 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(4)" @click="taskStatus(6)">In QA</a>
              </li> -->
              <!-- <li class="nav-item type3 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 7 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(4)" @click="taskStatus(7)">PR Review</a>
              </li> -->
              <li class="nav-item type3 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 3 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(3)" @click="taskStatus(3)">On Hold</a>
              </li>
              <li class="nav-item type3 mr-4">
                  <a class="nav-link demo" v-bind:class="[selectTab == 4 ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus(4)" @click="taskStatus(4)">Delivered</a>
              </li>
            </ul>
        </div>
         </template>
        <div v-if="!weekendFiltersProp" class="float-right ml-auto" style="margin-top: 6px" id="support_filter">
            <div class="float-left mr-3">
              <div class="has-search">
                <span class="fa fa-search form-control-feedback"></span>
                <input v-if="!weekendFiltersProp && $can('designer_task_search')" v-model="search" @keyup="taskSearch" type="text" style="background-color: #edf2f5"
                  class="form-control search" placeholder="Search Here..." />
              </div>
            </div>
            <!-- Filter Button-->
            <button  v-if="!weekendFiltersProp && $can('designer_task_filter')" class="btn btn-sm filter" style="border: 1px solid #48a6a6;padding: 6px 8px 3px 8px;" type="button" data-toggle="collapse"
              data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="ShowFilter"> 
              <i class="fa fa-filter" style="font-size:19px;color:#48a6a6;"></i>
            </button>

            <button v-if="!weekendFiltersProp && $can('designer_add_task')" @click="createTask" type="button" class="btn btn-sm float-right ml-2" style="
            color: white;
            padding: 5px 10px;
            cursor: pointer;
            border: 1px solid #48a6a6;
            padding: 7px 8px 3px 9px;
          ">
            <span class="fa fa-plus" style="font-size:18px;color:#48a6a6;"></span>
          </button>
            <!-- <router-link v-if="$route.fullPath == '/development-tasks'" to="/development-tasks/new-task" class="btn float-right ml-2 add-ticket" id="add_new_default" style="  padding: 5px 8px 2px 8px;"> <span  style="font-size:20px;color:#48a6a6"  class="fa fa-plus"></span></router-link> -->
        </div>
    </div>
        <div :class="show_filter" class="row collapse filter-button px-3" id="collapseExample">
          <div class="col-sm-12 col-md-3" >
              <div class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Customer</label>
                <multiselect  :options="orgList" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="organizations"
                 :multiple="true" label="name" track-by="id" style="font-size:12px !important" placeholder="All organizations">
                </multiselect>
              </div>
          </div>
          <div class="col-sm-12 col-md-3" >
              <div class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Urgency</label>
                <multiselect  :options="prioritiesList" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="urgency"
                  label="name" track-by="value" style="font-size:12px !important" placeholder="Urgency">
                </multiselect>
              </div>
          </div>

          <div class="col-sm-12 col-md-3" >
              <div class="form-group" style="display:flex; flex-direction:column;">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Delivery Date</label>
                  <date-range-picker v-model="dateRange"></date-range-picker>
              </div>
          </div>
          <div  v-if="[userRoles.csm, userRoles.super_admin,userRoles.admin,userRoles.adh,userRoles.adh_helper,userRoles.development_lead].includes(role)" class="col-sm-12 col-md-3" >
              <div class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Team</label>
                <multiselect @input="changeTeam()"  :options="teams" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="department"
                  label="name" track-by="id" style="font-size:12px !important" placeholder="Team">
                </multiselect>
              </div>
          </div>
          <div v-if="[userRoles.csm, userRoles.super_admin,userRoles.admin,userRoles.adh,userRoles.adh_helper,userRoles.development_lead].includes(role)" class="col-sm-12 col-md-3" >
              <div class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer</label>
                <multiselect   :options="allDevelopers" :selectedLabel="null" :deselectLabel="null" :allow-empty="true" :selectLabel="null" :searchable="true" v-model="developer"
                  label="full_name" track-by="id" style="font-size:12px !important" placeholder="Developer">
                </multiselect>
              </div>
          </div>
        </div>
        
        <!-- <div class="col-sm-12 col-md-6 " style=" display: flex; justify-content: right;  padding: 22px 17px 0px 0px;">
            <button type="button" class="btn btn-basic right mt-3 bg-green-default reset-button" style="margin: 0% 0% 5% 0%;">
                <span class="reset" @click="resetFilter"> Reset</span>
            </button>
        </div> -->
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import $ from 'jquery';
import VueSkeletonLoader from 'skeleton-loader-vue';
import taskForm from "./form.vue";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import axios from 'axios';
export default {
    components: {
      Multiselect, VueSkeletonLoader,DateRangePicker
    },
    
    props: ['orgList','developers','teams','weekendFiltersProp',"tasks"],
    data() {
        return{
            selectTab: 'all',
            search: '',
            organizations: [],
            selected_orgs: '',
            selected_urgency:'',
            urgency:'',
            taskType:'',
            selected_department:'',
            department: '',
            selected_developer:'',
            developer: '',
            status:'',
            selectTabFilter: "lastWeek",
            dateRange:{},
            role: JSON.parse(localStorage.getItem("role")),
            filters: {
              customers: [],
              priority: '',
              assigned_to: '',
              due_date_range: '',
              development_department: '',
            },
            team_developers :[],
            weekendFilters: [],
            allDevelopers : this.developers,
        }
    },
    computed: {
      prioritiesList: function () {
          return this.$store.getters['tasks/prioritiesList'];
      },
      show_filter: function () {
        localStorage.getItem('show_filter');
      },
      userRoles: function () {
				return this.$store.getters['persist/userRoles'];
			},
    },

    watch:{
      organizations: function(){
          this.filters.customers = this.organizations.map(({ id }) => id);
          this.getRecords();
        },
        urgency: function(){
          this.filters.priority = this.urgency != null ? this.urgency.value : '';
          this.getRecords();
        },
        department: function(){
           if(!this.department)
          {
            this.filters.development_department ='';
          }else{
          this.filters.development_department = this.department.id;
          this.developer='';
          }
          this.getRecords();
        },
        developer: function(){
          this.filters.assigned_to = this.developer != null ? this.developer.id : '';
          this.getRecords();
        },
        'developers': function(newValue){
         this.allDevelopers = newValue;
        },
        dateRange: function(){
          this.filters.due_date_range = this.dateRange;
          this.getRecords();
        },
    },
    methods:{
      changeTeam(){
               if(!this.department)
          {
            this.filters.development_department ='';
            this.allDevelopers=this.developers;
            this.developer ='';
          }else{
              this.team_developers = this.department.team_developer
                 .filter(developer =>
                    this.developers.some(alldev =>
                          alldev.id === developer.user_id)
                          )
                         .map(developer => developer.user_id);

                this.allDevelopers = this.developers.filter(developer =>
                    this.team_developers.includes(developer.id)
                );
          }

            },
            get_all_developers() {
                this.allDevelopers = this.developers;
            },


          filterByDate(tab) {
              this.selectTabFilter = tab;
              let startDate, endDate;
              const formatDate = (date) => {
              const year = date.getFullYear();
              const month = (date.getMonth() + 1).toString().padStart(2, '0');
              const day = date.getDate().toString().padStart(2, '0');
              return `${year}-${month}-${day}`;
          };

        if (tab === "lastWeek") {
          const today = new Date();
          const currentDayOfWeek = today.getDay();

          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - currentDayOfWeek - 6);
          lastWeekStart.setDate(lastWeekStart.getDate() - ((lastWeekStart.getDay() + 6) % 7) );

          lastWeekStart.setHours(0, 0, 0, 0);


          const lastWeekEnd = new Date(today);
          lastWeekEnd.setDate(today.getDate() - currentDayOfWeek);
          lastWeekEnd.setDate(lastWeekEnd.getDate() - ((lastWeekEnd.getDay() + 6) % 7) + 6);
          lastWeekEnd.setHours(23, 59, 59, 999);
          startDate = formatDate(lastWeekStart);
          endDate = formatDate(lastWeekEnd);
        }
        else if (tab === "thisWeek") {
            const today = new Date();
            const currentDayOfWeek = today.getDay();

            const thisWeekStart = new Date(today);
            thisWeekStart.setDate(today.getDate() - currentDayOfWeek + (currentDayOfWeek === 0 ? -6 : 1));
            thisWeekStart.setHours(0, 0, 0, 0);



            const thisWeekEnd = new Date(thisWeekStart);
            thisWeekEnd.setDate(thisWeekStart.getDate() + 6);
            thisWeekEnd.setHours(23, 59, 59, 999);

            startDate = formatDate(thisWeekStart);
            endDate = formatDate(thisWeekEnd);
        }
        else if (tab === "nextWeek") {
          const today = new Date();
          const currentDayOfWeek = today.getDay();
          const daysUntilNextMonday = (8 - currentDayOfWeek) % 7;
          const daysUntilNextMondayAdjusted = daysUntilNextMonday === 0 ? 7 : daysUntilNextMonday;

          const nextWeekStart = new Date(today);
          nextWeekStart.setDate(today.getDate() + daysUntilNextMondayAdjusted);
          nextWeekStart.setHours(0, 0, 0, 0);

          const nextWeekEnd = new Date(nextWeekStart);
          nextWeekEnd.setDate(nextWeekStart.getDate() + 6);
          nextWeekEnd.setHours(23, 59, 59, 999);
          startDate = formatDate(nextWeekStart);
          endDate= formatDate(nextWeekEnd);
        }
        this.performFiltering(startDate, endDate);

    },
      performFiltering(startDate, endDate) {
          this.$emit("skeletonLoader", true);
        const permission = {
        headers: {
          'X-Permission': 'designer_view_delivery_calendar' 
        }
      };
       axios.post("/common/designertask/delivery-calendar", {
        start_date: startDate,
        end_date: endDate
    },permission)
        .then((response) => {
        const filteredTasks = response.data.task;
        this.$emit("filteredTasks", filteredTasks);
         this.$emit("skeletonLoader", false);

        })
     },

        taskSearch() {
          if (this.search.replace(/\s/g, "").length || this.search == '') {
              this.filters.search = this.search;
              this.getRecords();
          }
        },
        ShowFilter(){
          this.show_filter == 'show' ?  localStorage.setItem('show_filter', false) :  localStorage.setItem('show_filter', 'show');
        },
        createTask() {
          this.$store.dispatch("modal/taskModal", {
            action: "create",
            title: "Add Task",
            show:true,
            formData: {
              developers: this.developers,
            },
            component: taskForm
          });
        },
        selectedStatus(event) {
            this.$emit("selectedTaskTab", event);
        },
        taskStatus(event) {
          this.selectTab = event;
          this.filters.status = event;
          this.getRecords();
        },
        getRecords(){
          this.$emit('update-parent-filters', this.filters);
          // this.skeletonLoader = true;
          // this.$emit("skeletonLoader", this.skeletonLoader);
          this.$parent.getRecords();
          // this.$store.dispatch("tasks/getAllTasks", [1, this.selectTab, this.search, this.filters]).then(() => {
          //   this.skeletonLoader = false;
          //   this.$emit("skeletonLoader", this.skeletonLoader);
          // });
        },
    },
    mounted() {
    if (this.weekendFiltersProp) {
        this.weekendFilters = this.weekendFiltersProp;
         this.filterByDate("lastWeek");
    }
},

    
};

</script>
<style >
#tabs .nav-link {
  background: transparent;
  color: rgb(66, 64, 64);
}
#tabs .active {
  background-color: #48a6a6 !important;
  color: white;
}
.daterangepicker.openscenter{
  left: 0% !important;
  transform: translate(-64%) !important;
}
.cancelBtn.btn.btn-sm.btn-secondary:hover{
  color: gray !important;
}
.applyBtn.btn.btn-sm.btn-success{
  background-color: #48a6a6  !important;
}
.applyBtn.btn.btn-sm.btn-success:hover{
  color: #48a6a6  !important;
  border-color: #48a6a6 !important;
  background-color: white !important;
}
.form-control.search{
  height: calc(1.5em + 0.65rem + 0px) !important;
}
@media screen and (max-width:425px){
  .mobile-nav{
    flex-wrap:nowrap;
    overflow: auto;
    max-width: 425px;
  }
}
</style>